// shared mixin for performance widgets
export default {
  props: {
    config: {
      type: Object,
    },
    dashboard: {
      type: Object,
    },
  },
  computed: {
    categoryIds() {
      const allCategories = this.$store.getters['categories/all'];
      if (this.resourceType === 'categoryType') {
        return allCategories.filter(c => c.categoryTypeId === this.resourceId).map(c => c.id);
      }

      if (this.resourceType === 'grouping') {
        const grouping = this.$store.getters['groupings/all'][this.resourceId];
        const categoryTypeIds = grouping.assetAssociations.filter(aa => aa.assetBType === 'CategoryType').map(aa => aa.assetBId);
        return allCategories.filter(c => categoryTypeIds.includes(c.categoryTypeId)).map(c => c.id);
      }

      return allCategories.map(c => c.id);
    },
    flashcardStates() {
      return this.$store.getters['flashcardStates/flashcardStateList'].filter(cs => this.categoryIds.includes(cs.categoryId));
    },
    resourceType() {
      if (!this.widgetConfig) return null;
      const keys = Object.keys(this.widgetConfig);
      if (keys.includes('groupingId')) {
        return 'grouping';
      }
      if (keys.includes('categoryTypeId')) {
        return 'categoryType';
      }
      return null;
    },
    resourceId() {
      if (!this.resourceType) return null;
      return this.widgetConfig[`${this.resourceType}Id`];
    },
    widgetConfig() {
      return this.config?.config;
    },
  },
};
